/* PDP 修复脚本 - scp-quick 滚动显示/隐藏 */

(function() {
  'use strict';

  function initQuickAddScroll() {
    var quickBar = document.querySelector('.scp-quick');
    if (!quickBar) return;

    var addToCartButton = document.querySelector('.scp-form .scp-button[type="submit"]');
    if (!addToCartButton) return;

    var lastScrollY = window.scrollY;
    var isVisible = false;

    function updateQuickBar() {
      var currentScrollY = window.scrollY;
      var addToCartRect = addToCartButton.getBoundingClientRect();

      // 判断 Add to Cart 按钮是否在视口上方（已经滚动过去）
      var isPastAddButton = addToCartRect.top < 0;

      // 判断滚动方向
      var isScrollingDown = currentScrollY > lastScrollY;

      // 显示/隐藏逻辑：
      // 1. 超过 Add to Cart 按钮
      // 2. 向下滚动时显示，向上滚动时隐藏
      var shouldShow = isPastAddButton && isScrollingDown;

      if (shouldShow !== isVisible) {
        isVisible = shouldShow;
        quickBar.classList.toggle('is-visible', isVisible);
      }

      lastScrollY = currentScrollY;
    }

    // 使用节流优化性能
    var ticking = false;
    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateQuickBar();
          ticking = false;
        });
        ticking = true;
      }
    }

    // 监听滚动事件
    window.addEventListener('scroll', requestTick, { passive: true });

    // 初始检查
    updateQuickBar();
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAddScroll);
  } else {
    initQuickAddScroll();
  }
})();
